let sidebar = require( './checkout-sidebar' );

let payee_switcher = (function( $ ) {

	let $payee_switcher;

	let _init = function() {
		$payee_switcher = $( '#payee-switcher' );

		if ( $payee_switcher.length > 0 ) {
			$payee_switcher.select2( {
				dropdownParent: $payee_switcher.closest( '.select-wrapper' )
			} );
			$payee_switcher.on( 'change', _switch_payee );
		}
	};

	let _switch_payee = function( e ) {
		$.post( ScriptData.ajaxurl, {
			action : 'crate_payee_switch',
			nonce  : ScriptData.crate_payee_switch_nonce,
			payee  : $( this ).val()
		}, _switch_payee_response );
	}

	let _switch_payee_response = function( response ) {
		console.log( response );

		if ( response.success ) {
			$( '#checkout-sidebar' ).replaceWith( response.sidebar );
			sidebar.init();

			if ( response.valid_forms.includes( 'online' ) ) {
				$( '.tab.type-online' ).slideDown();
			} else {
				$( '.tab.type-online' ).slideUp();
			}

			if ( response.valid_forms.includes( 'offline' ) ) {
				$( '.tab.type-offline' ).slideDown();
			} else {
				$( '.tab.type-offline' ).slideUp();
			}
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = payee_switcher;